// extracted by mini-css-extract-plugin
export default {"wrapper":"NewCardPayment_wrapper__-e9Xx","flexBox":"NewCardPayment_flexBox__4LoV4","title":"NewCardPayment_title__aB8tO"};